import { UseQueryResult } from 'react-query';
import { AxiosError, AxiosResponse, AxiosResponseHeaders } from 'axios';
import { MenuType } from 'api/models';
import { useGetOrderingDeadlinesApi } from 'hooks/useGetOrderingDeadlinesApi';
import { toBusinessDateTime } from 'utils/toBusinessDateTime';

// Accepts any order response that carries an `orderDate` (legacy or next-stack).
type OrderTiming = { orderDate?: string; menuType?: MenuType };

export const useIsEditable = (
  orderResponse: UseQueryResult<AxiosResponse<OrderTiming>>,
) => {
  const order = orderResponse.data?.data;
  const deadlines = useGetOrderingDeadlinesApi(orderResponse.isSuccess);

  if ((orderResponse.error as AxiosError)?.response?.status === 404) {
    return true;
  }

  if (!orderResponse.isSuccess || !order?.orderDate || !deadlines.data) {
    return false;
  }

  const { unavailableAt, zone } = deadlines.data.data;
  const { date: serverTime } = orderResponse.data
    .headers as AxiosResponseHeaders;
  const now = toBusinessDateTime(new Date(serverTime), zone);

  if (order.orderDate !== now.date) {
    return order.orderDate > now.date;
  }

  const deadline = unavailableAt[order.menuType ?? MenuType.Dinner];

  return !!deadline && now.time < deadline;
};
